import React from "react";

import { Card, Typography, Empty } from "antd";

const { Title } = Typography;
const Departments = () => {
  return (
    <Card style={{ width: "100%", marginBottom: "10px" }} hoverable>
      <Title level={5} style={{ marginInline: "10px" }}>
        Course Departments
      </Title>
      <Empty />
    </Card>
  );
};

export default Departments;
